import { useCallback } from 'react';

import { TrackingEvents, sendLoggingEvents } from '../events';
import { useAtomCallbackMemoized } from '../hooks/useAtomCallbackMemoized';
import { useRoomEventListeners } from '../session/events/useRoomEventListeners';
import { RoomEventHandlerMap, participantCountAtom } from '../video-sdk';
import { useProviderDisconnectRoomCallback } from './useProviderDisconnectRoomCallback';

export function useProviderRoomListeners() {
  const getParticipantCount = useAtomCallbackMemoized((get) => get(participantCountAtom), []);

  const onPageUnload = () => {
    sendLoggingEvents(TrackingEvents.PROVIDER_TAB_CLOSE);
  };
  const disconnectRoom = useProviderDisconnectRoomCallback();
  const onRoomDisconnect = useCallback<RoomEventHandlerMap['disconnected']>(
    (_room, _error, { isRoomRejoinable } = {}) => {
      // rejoin flow - skip provider-specific cleanup
      if (isRoomRejoinable) {
        return;
      }
      disconnectRoom();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
  const onParticipantDisconnect = useCallback(
    function disconnectFromEmptyRoom() {
      if (getParticipantCount()) return;
      disconnectRoom();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  useRoomEventListeners({
    onParticipantDisconnect,
    onRoomDisconnect,
    onPageUnload,
  });
}
